var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopy = function SvgCopy(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C4 3.44772 4.44772 3 5 3H16C16.5523 3 17 3.44772 17 4V5H7C6.44772 5 6 5.44772 6 6V18H5C4.44772 18 4 17.5523 4 17V4ZM7 7C7 6.44772 7.44772 6 8 6H19C19.5523 6 20 6.44772 20 7V21C20 21.5523 19.5523 22 19 22H8C7.44772 22 7 21.5523 7 21V7ZM18 9H9V10H18V9ZM18 12H9V13H18V12ZM9 15H18V16H9V15ZM18 18H9V19H18V18Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export default ForwardRef;